import { axios } from '../utils/apiUtils';
import React, { useState } from 'react';
import { Alert, Button, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const styles = {
  alert: {
    marginTop: '16px',
    marginBottom: '16px',
  },
};

const PasswordRecovery = (props) => {
  const { t } = useTranslation();

  const [showError, setShowError] = useState();

  const sendResetPassword = (event) => {
    event.preventDefault();

    axios.post(
      `${process.env.REACT_APP_API_URL}/users/send_password_reset_by_email/${props.user}`,
      {},
      {
        headers: { 'Content-Type': 'application/json' }
      },
    ).then((loginResponse) => {
      props.onClose();
    }).catch(() => {
      setShowError(true);
    });
  }


  return (
    <Modal show="true" onHide={props.onClose}>
      <Modal.Header closeButton>
        <Modal.Title>{t('login.password_reset.modal.title')}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {showError && 
          <Alert
            style={styles.alert}
            variant="danger" >
              {t('login.password_reset.modal.error')}
          </Alert>
        }

        <p>{t('login.password_reset.modal.message')}</p>
      </Modal.Body>

      <Modal.Footer>
        <Button
          variant="outline-success"
          onClick={(event) => sendResetPassword(event)}
        >{t('login.password_reset.modal.buttons.send')}</Button>
        <Button
          variant="outline-danger"
          onClick={() => props.onClose()}
        >{t('login.password_reset.modal.buttons.cancel')}</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PasswordRecovery;